<template>
  <header class="header pt-3 text-white position-relative">
    <vue-particles
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="polygon"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      :clickEffect="false"
    >
    </vue-particles>
    <nav
      class="header__nav d-none d-lg-block w-100 position-absolute"
      :class="{ fixed: fixedNav }"
    >
      <div class="container">
        <div class="row">
          <div class="col-2">
            <a href="/">
              <h2 class="font-weight-bold m-0 header__logo">
                <span class="header__logo__firstname">ROBUST</span>
                <span class="ml-2 text-white">OFFICE</span>
              </h2>
            </a>
          </div>
          <div class="col-10">
            <ul
              class="d-flex header__nav-list m-0 w-100 justify-content-between"
            >
              <li>
                <a href="/">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" v-scroll-to="'#services'">
                  Services
                </a>
              </li>
              <li>
                <a href="#recentwork" v-scroll-to="'#recentwork'">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#about" v-scroll-to="'#about'">
                  About
                </a>
              </li>

              <li>
                <a href="#reviews" v-scroll-to="'#reviews'">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" v-scroll-to="'#contact'">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div class="d-block d-lg-none position-absolute w-100 header__nav">
      <div class="container w-100 h-100">
        <div class="d-flex justify-content-between  align-items-center">
          <h2 class="font-weight-bold m-0 header__logo">Robust Office</h2>
          <div
            class="burger burger-squeeze"
            aria-controls="header-sb"
            aria-expanded="false"
            :class="{ open: sbState }"
            @click="sbState = !sbState"
          >
            <div class="burger-lines"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center header__content w-100">
      <h1
        class="text-portfolio text-white text-uppercase header__heading-main underline letter-spacing-lg mb-0 mx-auto mb-2"
      >
        Welcome to
        <span class="text-portfolio2">Robust Office</span>
      </h1>
      <div class="header__web-development mt-3 mt-sm-4 letter-spacing-md">
        <h1>
          We Work In
          <br class="d-block d-sm-none" />
          <span
            class="text-portfolio2 header__web-development__variable position-relative"
          ></span>
        </h1>
      </div>
      <button
        @click="openModal"
        class="btn btn-portfolio1 mt-5 text-portfolio4 font-weight-bold letter-spacing-md text-uppercase px-5 py-3"
      >
        Get Quote
      </button>
    </div>

    <b-sidebar
      v-model="sbState"
      class="d-block d-lg-none"
      id="header-sb"
      :backdrop="true"
    >
      <div class="px-3 py-2">
        <h2 class="font-weight-bold m-0 header__logo">Robust Office</h2>
        <ul class="header__nav-list m-0 w-50 pl-0">
          <li>
            <a href="/">
              Home
            </a>
          </li>
          <li>
            <a href="#services" v-scroll-to="'#services'">
              Services
            </a>
          </li>
          <li>
            <a href="#recentwork" v-scroll-to="'#recentwork'">
              Portfolio
            </a>
          </li>
          <li>
            <a href="#about" v-scroll-to="'#about'">
              About
            </a>
          </li>

          <li>
            <a href="#reviews" v-scroll-to="'#reviews'">
              Testimonials
            </a>
          </li>
          <li>
            <a href="#contact" v-scroll-to="'#contact'">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </b-sidebar>
    <b-modal
      class="quoteModal"
      hide-footer
      hide-header
      centered
      v-model="quotemodal"
    >
      <ModalContent />
    </b-modal>
  </header>
</template>

<script>
import ModalContent from "../Home/ModalContent.vue";
export default {
  components: {
    ModalContent,
  },
  data() {
    return {
      sbState: false,
      fixedNav: false,
      quotemodal: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    modalvalue(newValue) {
      this.quotemodal = newValue;
    },
  },
  computed: {
    modalvalue() {
      return this.$store.state.modal;
    },
  },
  methods: {
    openModal() {
      this.quotemodal = !this.quotemodal;
      this.$store.commit("quoteModal", this.quotemodal);
    },
    handleScroll() {
      if (window.scrollY > 0) {
        this.fixedNav = true;
      } else {
        this.fixedNav = false;
      }

      // const scrollTopBtn = document.querySelector(".scroll-top-btn");

      // if (window.scrollY > 200) {
      //   scrollTopBtn.classList.remove("d-none");
      //   scrollTopBtn.classList.add("d-block");
      // } else {
      //   scrollTopBtn.classList.remove("d-block");
      //   scrollTopBtn.classList.add("d-none");
      // }
    },
  },
};
</script>

<style></style>
